const SESSION_KEY = 'fvl-demo-mode'
const PORTAL_API =
  import.meta.env.VITE_PORTAL_API_URL ||
  'https://sso.fvlconsorcios.com.br'

let cached = null
let bootstrapped = false

export async function bootstrapDemoMode() {
  if (bootstrapped) return cached
  bootstrapped = true

  try {
    const stored = sessionStorage.getItem(SESSION_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      if (parsed.exp > Math.floor(Date.now() / 1000)) {
        cached = parsed
      } else {
        sessionStorage.removeItem(SESSION_KEY)
      }
    }
  } catch {
    sessionStorage.removeItem(SESSION_KEY)
  }

  const params = new URLSearchParams(window.location.search)
  const token = params.get('demo')

  if (token) {
    params.delete('demo')
    const qs = params.toString()
    const newUrl = `${window.location.pathname}${qs ? '?' + qs : ''}${window.location.hash}`
    window.history.replaceState({}, document.title, newUrl)

    try {
      const resp = await fetch(
        `${PORTAL_API}/api/demo/verify?token=${encodeURIComponent(token)}`,
      )
      if (resp.ok) {
        const data = await resp.json()
        if (data.valid) {
          cached = data
          sessionStorage.setItem(SESSION_KEY, JSON.stringify(data))
        }
      }
    } catch (err) {
      console.warn('[demo-mode] verify failed:', err)
    }
  }

  return cached
}

export function isDemoMode() {
  return cached !== null
}

export function getDemoSession() {
  return cached
}

export function clearDemoMode() {
  cached = null
  sessionStorage.removeItem(SESSION_KEY)
}

export const DEMO_USER_ID = '00000000-0000-0000-0000-000000000d3e'

export function buildDemoAuthSession() {
  const session = getDemoSession()
  const now = Math.floor(Date.now() / 1000)
  return {
    access_token: 'demo',
    refresh_token: 'demo',
    expires_in: 3600,
    expires_at: now + 3600,
    token_type: 'bearer',
    user: {
      id: DEMO_USER_ID,
      aud: 'authenticated',
      email: session?.portal_email ?? 'demo@fvlconsorcios.com.br',
      role: 'authenticated',
      app_metadata: { provider: 'demo', role: 'owner' },
      user_metadata: { full_name: 'Usuário Demo' },
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      identities: [],
    },
  }
}
